import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const ITGoodsShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="IT Goods"
    sectionKey="IT Goods"
    backRoute="/sections/it-goods"
  />
);

export default ITGoodsShipmentRequest;
